import { LANGUAGES, LocalizedText } from 'apollo/localizedTypes';
import isEmptyRichText from './isEmptyRichText';

const clearEmptyRichText = (value?: LocalizedText | null): LocalizedText =>
  LANGUAGES.reduce((cleared, language) => {
    const text = value?.[language];
    return { ...cleared, [language]: isEmptyRichText(text) ? '' : text };
  }, {}) as LocalizedText;

export default clearEmptyRichText;
